module.exports = __webpack_public_path__ + "static/media/nextgen.60e05c41.jpeg";